import { CoplaneFooter } from "./CoplaneFooter";
import { PageHeader } from "./PageHeader";

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen w-full bg-white text-black relative">
      <div className="relative z-50">
        <PageHeader inlineLogo={true} />
      </div>
      <main className="relative z-10 bg-white pt-18 md:pt-18 min-h-screen">
        {children}
      </main>
      <CoplaneFooter />
    </div>
  );
}

